// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2pr5d","actionsCol":"EnrolledClinics_actionsCol__an9VC"};